<template lang="pug">
.lessonBackground(
  v-if="subject"
  :class="[cssClass]"
)
  .icons( v-if="icons?.length" )
    ui-svg-icon.icon(
      v-for="(icon, index) in icons"
      :key="index"
      iconsFolderPath="assets/images/bg/"
      :name="icon"
      :size="300"
      :originalColors="true"
    )
</template>

<script>
import { computed } from 'vue'
import Subject from '@/models/Subject'
import { subjects } from '@/hooks/useSubjectsInfo'

export default {
  props: {
    subject: {
      type: Subject,
      default: null
    }
  },
  setup (props) {
    const subjectCode = computed(() => props.subject?.code)
    return {
      cssClass: computed(() => subjects[subjectCode.value]?.cssClass),
      icons: computed(() => subjects[subjectCode.value]?.bgIcons)
    }
  }
}
</script>

<style lang="sass" scoped>
.lessonBackground
  position: absolute
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: -1

  > .icons
    position: relative
    > .icon
      position: fixed
      &:nth-child(1)
        top: 6*$u
        left: -5*$u
      &:nth-child(2)
        top: -3*$u
        right: -5*$u
      &:nth-child(3)
        bottom: 10*$u
        right: -25*$u
      &:nth-child(4)
        bottom: 0
        left: 2*$u

  &._russian
    background-color: $cRusBgLight

  &._math
    background-color: $cMathBgLight

</style>
